import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BsBoxSeam, BsTruck, BsCalendar } from "react-icons/bs";

import { Instruction, When } from "../../../../models/instruction";
import { InstructionWhen } from "../../../../util/enums";
import InstructionItem from "./InstructionItem";
import useStyles from "./styles";

type Props = {
  instructions?: Instruction[];
  isOnViewMode?: boolean;
  typeWhens: When[];
  onUpdateInstruction: (instruction: Instruction) => void;
  onRemoveInstruction: (instruction: Instruction) => void;
  isOrder?: boolean;
};

const InstructionsList = ({
  instructions,
  typeWhens,
  isOnViewMode = false,
  onUpdateInstruction,
  onRemoveInstruction,
  isOrder = false,
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  const [uplifts, setUplifts] = useState<Instruction[]>([]);
  const [deliveries, setDeliveries] = useState<Instruction[]>([]);
  const [coordinators, setCoordinators] = useState<Instruction[]>([]);

  useEffect(() => {
    filterInstructions();
  }, [instructions]);

  const filterInstructions = () => {
    const uplifts =
      instructions?.filter((instruction) => instruction.when?.toLowerCase().includes("uplift")) ||
      [];
    const deliveries =
      instructions?.filter((instruction) => instruction.when?.toLowerCase().includes("delivery")) ||
      [];
    const coordinators =
      instructions?.filter((instruction) =>
        instruction.when?.toLowerCase().includes("coordinator")
      ) || [];

    setUplifts(uplifts);
    setDeliveries(deliveries);
    setCoordinators(coordinators);
  };

  const renderIcon = (icon: string) => {
    switch (icon) {
      case InstructionWhen.UPLIFT:
        return <BsBoxSeam className={classes.iconTitle} size={20} />;
      case InstructionWhen.DELIVERY:
        return <BsTruck className={classes.iconTitle} size={20} />;
      case InstructionWhen.COORDINATOR:
        return <BsCalendar className={classes.iconTitle} size={20} />;
      default:
        return <></>;
    }
  };

  const renderWhenItem = (when: When, instructionsList: Instruction[]) => (
    <Grid
      className={classes.whenGrid}
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={2}
    >
      <span className={classes.whenUpperTitle}>{translate("when").toLocaleUpperCase()}</span>
      <Grid className={classes.titleGrid} container direction="row" alignItems="center">
        <Grid className={classes.iconTitleGrid} item>
          {renderIcon(when.value)}
        </Grid>
        <Grid item>
          <span data-cy="title-when" className={classes.title}>
            {when.label}
          </span>
        </Grid>
      </Grid>
      {instructionsList &&
        instructionsList.map((instruction, index: number) => (
          <InstructionItem
            key={index}
            isOnViewMode={isOnViewMode}
            instruction={instruction}
            onUpdateInstruction={onUpdateInstruction}
            onRemoveInstruction={onRemoveInstruction}
            isOrder={isOrder}
          />
        ))}
    </Grid>
  );

  return (
    <div className={classes.mainDiv}>
      {instructions && instructions.length > 0 ? (
        <div className={classes.whenDiv}>
          <div className={classes.line} />
          {uplifts && uplifts.length > 0 ? renderWhenItem(typeWhens[0], uplifts) : null}
          {deliveries && deliveries.length > 0 ? renderWhenItem(typeWhens[1], deliveries) : null}
          {coordinators && coordinators.length > 0
            ? renderWhenItem(typeWhens[2], coordinators)
            : null}
        </div>
      ) : null}
    </div>
  );
};

export default InstructionsList;
